import React from 'react'
import { CompetitionRound } from '@/types'
import { Heat } from './Heat'

interface RoundsDisplayProps {
  rounds: CompetitionRound[]
  currentRoundIndex: number
  currentHeatIndex: number
}

export const RoundsDisplay: React.FC<RoundsDisplayProps> = ({ rounds, currentRoundIndex, currentHeatIndex }) => {
  return (
    <div className="space-y-4">
      {rounds.slice(0, currentRoundIndex + 1).map((round, roundIndex) => (
        <div key={round.key} className="space-y-2">
          <div className="overflow-x-auto">
            <div className="flex gap-4 pb-2 min-w-min">
              {round.heats.map((heat, heatIndex) => {
                return (
                  <div key={`${round.key}-${heatIndex}`} className="flex-shrink-0">
                    <Heat heat={heat} roundKey={round.key} heatIndex={heatIndex} />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
